import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, ChevronRight, Cpu, Phone } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SideMenu from '../components/SideMenu';
import Daten from '../components/Daten';
import PrivacyPolicy from '../components/PrivacyPolicy';
import CookieConsent from '../components/CookieConsent';
import { Toaster } from '../components/ui/toaster';

export default function DatenPage() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  // SEO: page title + meta description
  useEffect(() => {
    document.title = 'Revenda Autorizada Daten em Ribeirão Preto | Notebooks, Desktops e Servidores | Fernando Tech';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement('meta'); meta.name = 'description'; document.head.appendChild(meta); }
    meta.content = 'Fernando Tech é revendedor autorizado Daten em Ribeirão Preto. Notebooks, desktops, servidores e monitores Daten com garantia. Equipamentos homologados para licitações públicas.';
    return () => { document.title = 'Fernando Tech | Suporte Premium'; };
  }, []);

  return (
    <div className="bg-slate-950 min-h-screen">
      <Navbar />

      {/* Breadcrumb */}
      <div className="pt-[90px] xl:pt-[140px] pb-2 bg-slate-900/60 border-b border-slate-800">
        <div className="container mx-auto px-4">
          <nav className="flex items-center gap-1.5 text-sm text-slate-500" aria-label="Breadcrumb">
            <Link to="/" className="flex items-center gap-1 hover:text-cyan-400 transition-colors">
              <Home className="w-3.5 h-3.5" /> Home
            </Link>
            <ChevronRight className="w-3.5 h-3.5 text-slate-700" />
            <span className="flex items-center gap-1 text-cyan-400">
              <Cpu className="w-3.5 h-3.5" /> Revenda Daten
            </span>
          </nav>
        </div>
      </div>

      {/* Conteúdo principal */}
      <Daten />

      {/* CTA section */}
      <section className="bg-gradient-to-r from-[#1d3557]/60 to-[#457b9d]/30 border-t border-slate-800 py-12">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-white font-bold text-2xl md:text-3xl mb-3">
            Solicite um orçamento Daten sem compromisso
          </h2>
          <p className="text-slate-400 text-base mb-8 max-w-xl mx-auto">
            Como revenda autorizada Daten, oferecemos as melhores condições para empresas, setor público e uso corporativo.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.me/5516991378312?text=Olá!%20Tenho%20interesse%20em%20equipamentos%20Daten.%20Podem%20me%20enviar%20um%20orçamento?"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-8 py-3.5 bg-emerald-600 hover:bg-emerald-700 text-white font-bold rounded-full shadow-lg shadow-emerald-500/20 transition-all text-base"
              data-testid="daten-cta-whatsapp"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.533 5.85L0 24l6.338-1.497A11.93 11.93 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.789 9.789 0 01-4.99-1.364l-.358-.213-3.76.888.937-3.647-.234-.374A9.786 9.786 0 012.182 12C2.182 6.57 6.57 2.182 12 2.182c5.43 0 9.818 4.388 9.818 9.818 0 5.43-4.388 9.818-9.818 9.818z"/></svg>
              Solicitar Orçamento pelo WhatsApp
            </a>
            <a
              href="tel:16991378312"
              className="flex items-center gap-2 px-8 py-3.5 bg-slate-800 hover:bg-slate-700 border border-slate-600 hover:border-cyan-500/50 text-white font-bold rounded-full transition-all text-base"
              data-testid="daten-cta-phone"
            >
              <Phone className="w-5 h-5 text-cyan-400" />
              (16) 99137-8312
            </a>
          </div>
        </div>
      </section>

      <Footer onOpenPrivacyPolicy={() => setShowPrivacyPolicy(true)} />
      <SideMenu />
      <CookieConsent onOpenPrivacyPolicy={() => setShowPrivacyPolicy(true)} />
      <PrivacyPolicy isOpen={showPrivacyPolicy} onClose={() => setShowPrivacyPolicy(false)} />
      <Toaster />
    </div>
  );
}
